import { baseApiV2 } from '@verantos-dev/app-state-base';
import { getProjectsBasePath } from '@verantos-dev/core-constants';
import { ListResponse, ObjectResponse } from '@verantos-dev/types-common';
import { LegacyDatasetDataCatalogDetails } from '@verantos-dev/types-datasets';

import { DATASETS_BASE_PATH, RELEASES_BASE_PATH } from './constants';

export const legacyDatasetApiSlice = baseApiV2
  .enhanceEndpoints({
    addTagTypes: ['datatsets'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDatasetReleases: builder.query<
        ListResponse<{
          productId: string;
          productName: string;
        }>,
        undefined
      >({
        query: () => `${getProjectsBasePath()}/dataset-releases`,
      }),
      getDatasetReleaseById: builder.query<ObjectResponse<LegacyDatasetDataCatalogDetails>, string>(
        {
          query: (releaseId: string) => `/${DATASETS_BASE_PATH}/${RELEASES_BASE_PATH}/${releaseId}`,
        }
      ),
    }),
  });

export const { useGetDatasetReleasesQuery, useGetDatasetReleaseByIdQuery } = legacyDatasetApiSlice;
